module.exports = __webpack_public_path__ + "static/img/no-head-img.f795e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userinfo/no-head-img.png
// module id = Q0t0
// module chunks = 1